// frontend/src/components/qa/QAFab.tsx
// Floating red corner button. Collapsible to an 8px edge nub.
// State persisted in localStorage across reloads.

import { useState, useEffect } from 'react'
import { useLanguage } from '../../i18n/index.jsx'

const LS_KEY = 'stagewise:qa:fab-collapsed'

interface QAFabProps {
  onOpen: () => void
}

export default function QAFab({ onOpen }: QAFabProps) {
  const { t } = useLanguage()
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(LS_KEY) === '1')

  useEffect(() => {
    localStorage.setItem(LS_KEY, collapsed ? '1' : '0')
  }, [collapsed])

  if (collapsed) {
    return (
      <div
        className="qa-fab-nub"
        onClick={() => setCollapsed(false)}
        title={t('qaFabExpand')}
        role="button"
        tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') setCollapsed(false) }}
      />
    )
  }

  return (
    <div className="qa-fab-wrap">
      <button className="qa-fab" onClick={onOpen} title={t('qaFabTooltip')} aria-label={t('qaDrawerTitle')}>
        QA
      </button>
      <button
        className="qa-fab-collapse"
        onClick={() => setCollapsed(true)}
        title={t('qaFabCollapse')}
        aria-label={t('qaFabCollapse')}
      >
        ×
      </button>
    </div>
  )
}
